import { Box, Divider } from '@mui/material';
import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import { Icon } from 'react-feather';
import { Link, LinkProps, useLocation } from 'react-router';

import isNavItemActive from './isNavItemActive';

const MobileItem = ({
  children,
  path,
  onClick,
  className,
  boxClassName,
  icon: IconComponent,
  divider,
}: PropsWithChildren<{
  path?: LinkProps['to'];
  onClick?: () => void;
  className?: string;
  boxClassName?: string;
  icon?: Icon;
  divider?: boolean;
}>): React.JSX.Element => {
  const { pathname } = useLocation();
  // Shared with `Item`, which the drawer mirrors off the same `navbarItems`.
  // Read the helper before adding a nav item nested under another item's path.
  const isActive = isNavItemActive(pathname, path);

  return (
    <li className={className}>
      <Box
        component={path ? Link : 'div'}
        to={path}
        onClick={onClick}
        role={path ? undefined : 'button'}
        tabIndex={path ? undefined : 0}
        aria-current={isActive ? 'page' : undefined}
        onKeyDown={
          path
            ? undefined
            : (e: React.KeyboardEvent) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onClick?.();
                }
              }
        }
        className={clsx(
          'flex w-full cursor-pointer items-center gap-12 px-12 py-10',
          isActive
            ? 'rounded-sm bg-brand-primary font-semibold text-white dark:bg-brand-light dark:text-brand-primary'
            : 'text-on-surface-secondary',
          boxClassName
        )}
      >
        {IconComponent && (
          <IconComponent
            size={16}
            className={clsx('shrink-0', isActive ? 'text-current' : 'text-gray-400')}
          />
        )}
        {children}
      </Box>
      {divider && <Divider className="my-2" />}
    </li>
  );
};

export default MobileItem;
